import { all, put, select } from 'redux-saga/effects';
import type { SagaIterator } from 'redux-saga';
import { selectors, withOffset } from '../../Stream';
import { getPostStreamIdFromMediaSource } from '../helpers';
import { DEVIATIONS_PER_FETCH } from '../constants';
import { initPostStream } from '../actions';
import type { PostStreamParams } from '../types';

function* handleInitPostStream(
  action: ReturnType<typeof initPostStream>
): SagaIterator {
  const mediaSource = action.payload;
  if (!mediaSource) {
    return;
  }
  const streamId = getPostStreamIdFromMediaSource(mediaSource);
  const isStreamInitialized: ReturnType<typeof selectors.isInitialized> =
    yield select(selectors.isInitialized, streamId);
  if (isStreamInitialized) {
    return;
  }

  const streamParams: PostStreamParams = {
    type: mediaSource,
  };

  yield all([
    put(
      withOffset.actions.initialize({
        streamId,
        itemsPerFetch: DEVIATIONS_PER_FETCH,
        streamParams,
      })
    ),
    put(withOffset.actions.fetch(streamId)),
  ]);
}

export default handleInitPostStream;
